import './service.svelte.css.proxy.js';
/* src/routes/service.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	query_selector_all,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import Nav from "../../_components/navigation/Nav.svelte.js";
import Wrap from "../../_components/slot/Wrap.svelte.js";
import Inner from "../../_components/slot/Inner.svelte.js";
import Section from "../../_components/slot/Section.svelte.js";
import Columns from "../../_components/column/Columns.svelte.js";
import Column from "../../_components/column/Column.svelte.js";
import MainVisual from "../../_components/service/MainVisual.svelte.js";
import Breadcrumb from "../../_components/block/Breadcrumb.svelte.js";
import Title from "../../_components/block/Title.svelte.js";
import Heading from "../../_components/block/Heading.svelte.js";
import Hr from "../../_components/element/Hr.svelte.js";
import Item from "../../_components/slot/Item.svelte.js";

function create_default_slot_33(ctx) {
	let mainvisual;
	let current;
	mainvisual = new MainVisual({});

	return {
		c() {
			create_component(mainvisual.$$.fragment);
		},
		l(nodes) {
			claim_component(mainvisual.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(mainvisual, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(mainvisual.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(mainvisual.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(mainvisual, detaching);
		}
	};
}

// (32:0) <Section kind="gapless">
function create_default_slot_32(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_33] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (39:2) <Wrap fullOnMobile>
function create_default_slot_31(ctx) {
	let breadcrumb;
	let t;
	let title;
	let current;
	breadcrumb = new Breadcrumb({ props: { paths: /*paths*/ ctx[0] } });

	title = new Title({
			props: {
				name: "サービス案内",
				en: "Service information"
			}
		});

	return {
		c() {
			create_component(breadcrumb.$$.fragment);
			t = space();
			create_component(title.$$.fragment);
		},
		l(nodes) {
			claim_component(breadcrumb.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(title.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(breadcrumb, target, anchor);
			insert(target, t, anchor);
			mount_component(title, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(breadcrumb.$$.fragment, local);
			transition_in(title.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(breadcrumb.$$.fragment, local);
			transition_out(title.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(breadcrumb, detaching);
			if (detaching) detach(t);
			destroy_component(title, detaching);
		}
	};
}

// (38:0) <Section kind="top-small">
function create_default_slot_30(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_31] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (47:4) <Inner>
function create_default_slot_29(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("クルマのプロ集団として高い技術力を培ってきた当社では、軽自動車から普通自動車の小型・中型・大型、さらには大型特殊まで、様々な車両の車検整備ができる分解整備工場の認証を受けています。また、テスターラインを持ち、指定工場の認定も受けているので、自社内で完成検査まで一貫して対応できるのも大きく特徴です。これらの体制により、定期点検から車検整備、さらには一般整備まで、迅速かつ確実なサービスを提供しています。");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t = claim_text(p_nodes, "クルマのプロ集団として高い技術力を培ってきた当社では、軽自動車から普通自動車の小型・中型・大型、さらには大型特殊まで、様々な車両の車検整備ができる分解整備工場の認証を受けています。また、テスターラインを持ち、指定工場の認定も受けているので、自社内で完成検査まで一貫して対応できるのも大きく特徴です。これらの体制により、定期点検から車検整備、さらには一般整備まで、迅速かつ確実なサービスを提供しています。");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (46:2) <Wrap>
function create_default_slot_28(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_29] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (45:0) <Section kind="small">
function create_default_slot_27(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_28] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (54:2) <Inner>
function create_default_slot_26(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (53:0) <Wrap fullOnMobile>
function create_default_slot_25(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_26] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (63:6) <Item>
function create_default_slot_24(ctx) {
	let figure;
	let img;
	let img_src_value;

	return {
		c() {
			figure = element("figure");
			img = element("img");
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);
			img = claim_element(figure_nodes, "IMG", { src: true, alt: true, class: true });
			figure_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/syaken.jpg")) attr(img, "src", img_src_value);
			attr(img, "alt", "ご依頼から納車までの流れ");
			attr(img, "class", "svelte-15bvq7e");
			attr(figure, "class", "svelte-15bvq7e");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
		},
		d(detaching) {
			if (detaching) detach(figure);
		}
	};
}

// (61:4) <Inner>
function create_default_slot_23(ctx) {
	let heading;
	let t;
	let item;
	let current;

	heading = new Heading({
			props: {
				name: "ご依頼から納車までの流れ",
				image: "/images/service.png"
			}
		});

	item = new Item({
			props: {
				$$slots: { default: [create_default_slot_24] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t = space();
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t, anchor);
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t);
			destroy_component(item, detaching);
		}
	};
}

// (60:2) <Wrap>
function create_default_slot_22(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_23] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (59:0) <Section kind="small">
function create_default_slot_21(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_22] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (73:2) <Inner>
function create_default_slot_20(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (72:0) <Wrap fullOnMobile>
function create_default_slot_19(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_20] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (82:6) <Item>
function create_default_slot_18(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("受入検査から見積り、整備、完成検査まで自社内で一貫して行う整備体制のもと、安全・安心で迅速なサービスを提供しています。");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t = claim_text(p_nodes, "受入検査から見積り、整備、完成検査まで自社内で一貫して行う整備体制のもと、安全・安心で迅速なサービスを提供しています。");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (85:6) <Item>
function create_default_slot_17(ctx) {
	let figure;
	let img;
	let img_src_value;

	return {
		c() {
			figure = element("figure");
			img = element("img");
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);

			img = claim_element(figure_nodes, "IMG", {
				src: true,
				srcset: true,
				alt: true,
				class: true
			});

			figure_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/service-01.jpg")) attr(img, "src", img_src_value);
			attr(img, "srcset", "/images/service-01-sp.jpg 768w, /images/service-01.jpg");
			attr(img, "alt", "個人の普通自動車の整備");
			attr(img, "class", "svelte-15bvq7e");
			attr(figure, "class", "svelte-15bvq7e");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
		},
		d(detaching) {
			if (detaching) detach(figure);
		}
	};
}

// (80:4) <Inner>
function create_default_slot_16(ctx) {
	let heading;
	let t0;
	let item0;
	let t1;
	let item1;
	let current;

	heading = new Heading({
			props: {
				name: "個人の普通自動車の整備",
				image: "/images/service.png"
			}
		});

	item0 = new Item({
			props: {
				$$slots: { default: [create_default_slot_18] },
				$$scope: { ctx }
			}
		});

	item1 = new Item({
			props: {
				$$slots: { default: [create_default_slot_17] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t0 = space();
			create_component(item0.$$.fragment);
			t1 = space();
			create_component(item1.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t0 = claim_space(nodes);
			claim_component(item0.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(item1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t0, anchor);
			mount_component(item0, target, anchor);
			insert(target, t1, anchor);
			mount_component(item1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item0_changes.$$scope = { dirty, ctx };
			}

			item0.$set(item0_changes);
			const item1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item1_changes.$$scope = { dirty, ctx };
			}

			item1.$set(item1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item0.$$.fragment, local);
			transition_in(item1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item0.$$.fragment, local);
			transition_out(item1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t0);
			destroy_component(item0, detaching);
			if (detaching) detach(t1);
			destroy_component(item1, detaching);
		}
	};
}

// (79:2) <Wrap>
function create_default_slot_15(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_16] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (78:0) <Section kind="small">
function create_default_slot_14(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_15] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (99:2) <Inner>
function create_default_slot_13(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (98:0) <Wrap fullOnMobile>
function create_default_slot_12(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_13] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (108:6) <Item>
function create_default_slot_11(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("大手メーカーの指定サービス工場として、電気や通信といったインフラ整備で活躍する高所作業車の整備で高い技術力を発揮しています。");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t = claim_text(p_nodes, "大手メーカーの指定サービス工場として、電気や通信といったインフラ整備で活躍する高所作業車の整備で高い技術力を発揮しています。");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (111:6) <Item>
function create_default_slot_10(ctx) {
	let figure;
	let img;
	let img_src_value;

	return {
		c() {
			figure = element("figure");
			img = element("img");
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);

			img = claim_element(figure_nodes, "IMG", {
				src: true,
				srcset: true,
				alt: true,
				class: true
			});

			figure_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/service-02.jpg")) attr(img, "src", img_src_value);
			attr(img, "srcset", "/images/service-02-sp.jpg 768w, /images/service-02.jpg");
			attr(img, "alt", "法人の高所作業車の整備");
			attr(img, "class", "svelte-15bvq7e");
			attr(figure, "class", "svelte-15bvq7e");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
		},
		d(detaching) {
			if (detaching) detach(figure);
		}
	};
}

// (106:4) <Inner>
function create_default_slot_9(ctx) {
	let heading;
	let t0;
	let item0;
	let t1;
	let item1;
	let current;

	heading = new Heading({
			props: {
				name: "法人の高所作業車の整備",
				image: "/images/service.png"
			}
		});

	item0 = new Item({
			props: {
				$$slots: { default: [create_default_slot_11] },
				$$scope: { ctx }
			}
		});

	item1 = new Item({
			props: {
				$$slots: { default: [create_default_slot_10] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t0 = space();
			create_component(item0.$$.fragment);
			t1 = space();
			create_component(item1.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t0 = claim_space(nodes);
			claim_component(item0.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(item1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t0, anchor);
			mount_component(item0, target, anchor);
			insert(target, t1, anchor);
			mount_component(item1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item0_changes.$$scope = { dirty, ctx };
			}

			item0.$set(item0_changes);
			const item1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item1_changes.$$scope = { dirty, ctx };
			}

			item1.$set(item1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item0.$$.fragment, local);
			transition_in(item1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item0.$$.fragment, local);
			transition_out(item1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t0);
			destroy_component(item0, detaching);
			if (detaching) detach(t1);
			destroy_component(item1, detaching);
		}
	};
}

// (105:2) <Wrap>
function create_default_slot_8(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (104:0) <Section kind="small">
function create_default_slot_7(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (125:2) <Inner>
function create_default_slot_6(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (124:0) <Wrap fullOnMobile>
function create_default_slot_5(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (134:6) <Item>
function create_default_slot_4(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("定期自主検査を行わなければならない建設機械やフォークリフトの点検整備についても、特定自主検査工場の認定を受けています。");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t = claim_text(p_nodes, "定期自主検査を行わなければならない建設機械やフォークリフトの点検整備についても、特定自主検査工場の認定を受けています。");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (137:6) <Item>
function create_default_slot_3(ctx) {
	let figure;
	let img;
	let img_src_value;

	return {
		c() {
			figure = element("figure");
			img = element("img");
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);

			img = claim_element(figure_nodes, "IMG", {
				src: true,
				srcset: true,
				alt: true,
				class: true
			});

			figure_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/service-03.jpg")) attr(img, "src", img_src_value);
			attr(img, "srcset", "/images/service-03-sp.jpg 768w, /images/service-03.jpg");
			attr(img, "alt", "法人の高所作業車の整備");
			attr(img, "class", "svelte-15bvq7e");
			attr(figure, "class", "svelte-15bvq7e");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
		},
		d(detaching) {
			if (detaching) detach(figure);
		}
	};
}

// (132:4) <Inner>
function create_default_slot_2(ctx) {
	let heading;
	let t0;
	let item0;
	let t1;
	let item1;
	let current;

	heading = new Heading({
			props: {
				name: "特定自主検査登録工場",
				image: "/images/service.png"
			}
		});

	item0 = new Item({
			props: {
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	item1 = new Item({
			props: {
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t0 = space();
			create_component(item0.$$.fragment);
			t1 = space();
			create_component(item1.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t0 = claim_space(nodes);
			claim_component(item0.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(item1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t0, anchor);
			mount_component(item0, target, anchor);
			insert(target, t1, anchor);
			mount_component(item1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item0_changes.$$scope = { dirty, ctx };
			}

			item0.$set(item0_changes);
			const item1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item1_changes.$$scope = { dirty, ctx };
			}

			item1.$set(item1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item0.$$.fragment, local);
			transition_in(item1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item0.$$.fragment, local);
			transition_out(item1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t0);
			destroy_component(item0, detaching);
			if (detaching) detach(t1);
			destroy_component(item1, detaching);
		}
	};
}

// (131:2) <Wrap>
function create_default_slot_1(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (130:0) <Section kind="small">
function create_default_slot(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

function create_fragment(ctx) {
	let meta0;
	let meta1;
	let meta2;
	let meta3;
	let meta4;
	let t0;
	let nav;
	let t1;
	let section0;
	let t2;
	let section1;
	let t3;
	let section2;
	let t4;
	let wrap0;
	let t5;
	let section3;
	let t6;
	let wrap1;
	let t7;
	let section4;
	let t8;
	let wrap2;
	let t9;
	let section5;
	let t10;
	let wrap3;
	let t11;
	let section6;
	let current;
	nav = new Nav({ props: { segment: "service" } });

	section0 = new Section({
			props: {
				kind: "gapless",
				$$slots: { default: [create_default_slot_32] },
				$$scope: { ctx }
			}
		});

	section1 = new Section({
			props: {
				kind: "top-small",
				$$slots: { default: [create_default_slot_30] },
				$$scope: { ctx }
			}
		});

	section2 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_27] },
				$$scope: { ctx }
			}
		});

	wrap0 = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_25] },
				$$scope: { ctx }
			}
		});

	section3 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_21] },
				$$scope: { ctx }
			}
		});

	wrap1 = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_19] },
				$$scope: { ctx }
			}
		});

	section4 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_14] },
				$$scope: { ctx }
			}
		});

	wrap2 = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_12] },
				$$scope: { ctx }
			}
		});

	section5 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	wrap3 = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	section6 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			meta0 = element("meta");
			meta1 = element("meta");
			meta2 = element("meta");
			meta3 = element("meta");
			meta4 = element("meta");
			t0 = space();
			create_component(nav.$$.fragment);
			t1 = space();
			create_component(section0.$$.fragment);
			t2 = space();
			create_component(section1.$$.fragment);
			t3 = space();
			create_component(section2.$$.fragment);
			t4 = space();
			create_component(wrap0.$$.fragment);
			t5 = space();
			create_component(section3.$$.fragment);
			t6 = space();
			create_component(wrap1.$$.fragment);
			t7 = space();
			create_component(section4.$$.fragment);
			t8 = space();
			create_component(wrap2.$$.fragment);
			t9 = space();
			create_component(section5.$$.fragment);
			t10 = space();
			create_component(wrap3.$$.fragment);
			t11 = space();
			create_component(section6.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-5rs5on\"]", document.head);
			meta0 = claim_element(head_nodes, "META", { name: true, content: true });
			meta1 = claim_element(head_nodes, "META", { property: true, content: true });
			meta2 = claim_element(head_nodes, "META", { property: true, content: true });
			meta3 = claim_element(head_nodes, "META", { property: true, content: true });
			meta4 = claim_element(head_nodes, "META", { property: true, content: true });
			head_nodes.forEach(detach);
			t0 = claim_space(nodes);
			claim_component(nav.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(section0.$$.fragment, nodes);
			t2 = claim_space(nodes);
			claim_component(section1.$$.fragment, nodes);
			t3 = claim_space(nodes);
			claim_component(section2.$$.fragment, nodes);
			t4 = claim_space(nodes);
			claim_component(wrap0.$$.fragment, nodes);
			t5 = claim_space(nodes);
			claim_component(section3.$$.fragment, nodes);
			t6 = claim_space(nodes);
			claim_component(wrap1.$$.fragment, nodes);
			t7 = claim_space(nodes);
			claim_component(section4.$$.fragment, nodes);
			t8 = claim_space(nodes);
			claim_component(wrap2.$$.fragment, nodes);
			t9 = claim_space(nodes);
			claim_component(section5.$$.fragment, nodes);
			t10 = claim_space(nodes);
			claim_component(wrap3.$$.fragment, nodes);
			t11 = claim_space(nodes);
			claim_component(section6.$$.fragment, nodes);
			this.h();
		},
		h() {
			document.title = "サービス案内 | 協和自動車有限会社 | 群馬県前橋市で自動車車検・修理なら協和自動車";
			attr(meta0, "name", "description");
			attr(meta0, "content", "協和自動車有限会社のサービス案内です。私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			attr(meta1, "property", "og:url");
			attr(meta1, "content", "https://kyouwaji.com/service/");
			attr(meta2, "property", "og:title");
			attr(meta2, "content", "サービス案内 | 協和自動車有限会社 | 群馬県前橋市で自動車車検・修理なら協和自動車");
			attr(meta3, "property", "og:description");
			attr(meta3, "content", "協和自動車有限会社のサービス案内です。私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			attr(meta4, "property", "og:type");
			attr(meta4, "content", "article");
		},
		m(target, anchor) {
			append(document.head, meta0);
			append(document.head, meta1);
			append(document.head, meta2);
			append(document.head, meta3);
			append(document.head, meta4);
			insert(target, t0, anchor);
			mount_component(nav, target, anchor);
			insert(target, t1, anchor);
			mount_component(section0, target, anchor);
			insert(target, t2, anchor);
			mount_component(section1, target, anchor);
			insert(target, t3, anchor);
			mount_component(section2, target, anchor);
			insert(target, t4, anchor);
			mount_component(wrap0, target, anchor);
			insert(target, t5, anchor);
			mount_component(section3, target, anchor);
			insert(target, t6, anchor);
			mount_component(wrap1, target, anchor);
			insert(target, t7, anchor);
			mount_component(section4, target, anchor);
			insert(target, t8, anchor);
			mount_component(wrap2, target, anchor);
			insert(target, t9, anchor);
			mount_component(section5, target, anchor);
			insert(target, t10, anchor);
			mount_component(wrap3, target, anchor);
			insert(target, t11, anchor);
			mount_component(section6, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const section0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section0_changes.$$scope = { dirty, ctx };
			}

			section0.$set(section0_changes);
			const section1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section1_changes.$$scope = { dirty, ctx };
			}

			section1.$set(section1_changes);
			const section2_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section2_changes.$$scope = { dirty, ctx };
			}

			section2.$set(section2_changes);
			const wrap0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap0_changes.$$scope = { dirty, ctx };
			}

			wrap0.$set(wrap0_changes);
			const section3_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section3_changes.$$scope = { dirty, ctx };
			}

			section3.$set(section3_changes);
			const wrap1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap1_changes.$$scope = { dirty, ctx };
			}

			wrap1.$set(wrap1_changes);
			const section4_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section4_changes.$$scope = { dirty, ctx };
			}

			section4.$set(section4_changes);
			const wrap2_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap2_changes.$$scope = { dirty, ctx };
			}

			wrap2.$set(wrap2_changes);
			const section5_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section5_changes.$$scope = { dirty, ctx };
			}

			section5.$set(section5_changes);
			const wrap3_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap3_changes.$$scope = { dirty, ctx };
			}

			wrap3.$set(wrap3_changes);
			const section6_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section6_changes.$$scope = { dirty, ctx };
			}

			section6.$set(section6_changes);
		},
		i(local) {
			if (current) return;
			transition_in(nav.$$.fragment, local);
			transition_in(section0.$$.fragment, local);
			transition_in(section1.$$.fragment, local);
			transition_in(section2.$$.fragment, local);
			transition_in(wrap0.$$.fragment, local);
			transition_in(section3.$$.fragment, local);
			transition_in(wrap1.$$.fragment, local);
			transition_in(section4.$$.fragment, local);
			transition_in(wrap2.$$.fragment, local);
			transition_in(section5.$$.fragment, local);
			transition_in(wrap3.$$.fragment, local);
			transition_in(section6.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(nav.$$.fragment, local);
			transition_out(section0.$$.fragment, local);
			transition_out(section1.$$.fragment, local);
			transition_out(section2.$$.fragment, local);
			transition_out(wrap0.$$.fragment, local);
			transition_out(section3.$$.fragment, local);
			transition_out(wrap1.$$.fragment, local);
			transition_out(section4.$$.fragment, local);
			transition_out(wrap2.$$.fragment, local);
			transition_out(section5.$$.fragment, local);
			transition_out(wrap3.$$.fragment, local);
			transition_out(section6.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			detach(meta0);
			detach(meta1);
			detach(meta2);
			detach(meta3);
			detach(meta4);
			if (detaching) detach(t0);
			destroy_component(nav, detaching);
			if (detaching) detach(t1);
			destroy_component(section0, detaching);
			if (detaching) detach(t2);
			destroy_component(section1, detaching);
			if (detaching) detach(t3);
			destroy_component(section2, detaching);
			if (detaching) detach(t4);
			destroy_component(wrap0, detaching);
			if (detaching) detach(t5);
			destroy_component(section3, detaching);
			if (detaching) detach(t6);
			destroy_component(wrap1, detaching);
			if (detaching) detach(t7);
			destroy_component(section4, detaching);
			if (detaching) detach(t8);
			destroy_component(wrap2, detaching);
			if (detaching) detach(t9);
			destroy_component(section5, detaching);
			if (detaching) detach(t10);
			destroy_component(wrap3, detaching);
			if (detaching) detach(t11);
			destroy_component(section6, detaching);
		}
	};
}

function instance($$self) {
	const paths = [{ name: "HOME", href: "/" }, { name: "サービス案内" }];
	return [paths];
}

class Service extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Service;
//# sourceMappingURL=service.svelte.js.map
